'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const { Provider } = require('react-redux');
const { IntlProvider } = require('react-intl');
const { combineReducers, createStore, applyMiddleware } = require('redux');
const UserStore = require('../../../global/stores/UserStore');
const ContactDealerRenderer = require('../components/ContactDealerRenderer');
const authProcess = require('../../shared/helpers/relayAuthHelper');
const { constants: authConstants } = require('dibs-buyer-layout/src/utils/AuthModalLoader').default;
const { contactModal } = require('dibs-buyer-layout/src/entries/index');

const { track } = require('dibs-buyer-layout/src/utils/chat');

module.exports = options => {
    contactModal().then(mod => {
        const {
            PreContactDealer,
            Confirmation,
            ContactDealer,
            ContactDealerModal,
            MultiRequestContactDealerModal,
            MultiRequestContactDealer,
            GuidedCopy,
            LowBall,
            MakeOffer,
            ModalWrapper,
            reducers,
        } = mod;

        const store = createStore(
            combineReducers(reducers),
            applyMiddleware(require('redux-thunk').default)
        );
        const modalContainer = document.createElement('div');

        const {
            itemPk,
            linkLocation,
            dealerPk,
            sellerData,
            context,
            currency,
            currentStep,
            handleCtaClick,
            modalContentData,
            isRequestMoreImages,
            isVerifiedTrade,
            onFavoriteDealerSuccess,
        } = options;

        const fluxibleContext =
            context && context.getComponentContext ? context.getComponentContext() : context;

        const props = {
            itemPk,
            linkLocation,
            currentStep,
            handleCtaClick,
            modalContentData,
            isRequestMoreImages,
            isVerifiedTrade,
            onFavoriteDealerSuccess,
            dealerPk: sellerData ? sellerData.id : dealerPk,
        };
        const pageCurrency = context ? fluxibleContext.getStore(UserStore).getCurrency() : currency;

        const modalProps = Object.assign({}, props, {
            modalComponents: {
                PreContactDealer,
                Confirmation,
                ContactDealer,
                ContactDealerModal,
                MultiRequestContactDealerModal,
                MultiRequestContactDealer,
                GuidedCopy,
                LowBall,
                MakeOffer,
                ModalWrapper,
            },
            pageCurrency,
            chatTracking: track,
            startAuth: authProps =>
                authProcess({
                    ...authProps,
                    flow: authProps.makeOffer && authConstants.CONTACT_DEALER_FORM_FLOW,
                }),
        });

        ReactDOM.render(
            // todo: INTL-161 fix this up when locale is in server vars
            <IntlProvider locale="en">
                <Provider store={store}>
                    <ContactDealerRenderer modalProps={modalProps} />
                </Provider>
            </IntlProvider>,
            modalContainer
        );
    });
};



// WEBPACK FOOTER //
// ./assets/js/contact/dealer/helpers/contactDealerLauncher.jsx